import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "@common/components/Table/DataTableColumnHeader";
import { Policy } from "./ExpensePolicy";
import { Body } from "@hypercard/web-components";
import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from "@radix-ui/react-hover-card";
import { Card } from "@/components/ui/card";
import { ConfirmationDialog } from "@common/components/ConfirmationDialog/ConfirmationDialog";

export const policyTableColumns = (
  editPolicy: (policy: Policy) => void,
  removePolicy: (policy: Policy) => void,
  loading: boolean,
): ColumnDef<Policy>[] => [
  {
    accessorKey: "name",
    enableSorting: false,
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Name" />;
    },
  },
  {
    accessorKey: "type",
    enableSorting: false,
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Type" />;
    },
    cell: () => {
      return (
        <Body size="md" weight="regular">
          Expense Report
        </Body>
      );
    },
  },
  {
    accessorKey: "department",
    enableSorting: false,
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Departments" />;
    },
    cell: ({ row }) => {
      const departments = row.original.departments.map(
        (department) => department.name,
      );
      if (departments.length > 1) {
        return (
          <HoverCard>
            <HoverCardTrigger>{`${departments.length} Departments`}</HoverCardTrigger>
            <HoverCardPortal>
              <HoverCardContent>
                <Card className="p-4">
                  <ul className="flex flex-col gap-2">
                    {departments.map((department) => (
                      <li key={department}>
                        <Body
                          size="md"
                          weight="regular"
                          className="text-white/70"
                        >
                          &bull; {department}
                        </Body>
                      </li>
                    ))}
                  </ul>
                </Card>
              </HoverCardContent>
            </HoverCardPortal>
          </HoverCard>
        );
      }
      return (
        <Body size="md" weight="regular">
          {departments[0] || "Entire Company"}
        </Body>
      );
    },
  },
  {
    accessorKey: "actions",
    enableSorting: false,
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          className="flex justify-end"
          title="Actions"
        />
      );
    },
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Button
            variant="secondary"
            disabled={loading}
            onClick={() => editPolicy(row.original)}
            className="mr-2 min-w-[100px]"
          >
            Edit Policy
          </Button>
          <ConfirmationDialog
            title="Delete Expense Policy"
            description={`Are you sure you want to delete this expense policy?\nThis action cannot be undone.`}
            onConfirm={() => removePolicy(row.original)}
            confirmText="Delete Policy"
          >
            <Button
              variant="destructive"
              disabled={loading}
              className="mr-2 min-w-[100px]"
            >
              Delete
            </Button>
          </ConfirmationDialog>
        </div>
      );
    },
  },
];
